export default "__VITE_ASSET__DId9fXVR__"